import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { IROH_SERVICES_API_PREFIX } from "@/api/domain"
import type { Build } from "@/infra"
import type { Pagination, ProjectIdParam } from "@/types"

export const buildsApi = createApi({
  reducerPath: "buildsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${IROH_SERVICES_API_PREFIX}builds`,
    mode: "cors",
    credentials: "include",
  }),
  endpoints: (build) => ({
    buildsGetDns: build.query<Build[], ProjectIdParam & Pagination>({
      query: ({ project_id, offset, limit }) => ({
        url: `${project_id}/dns?offset=${offset}&limit=${limit}`,
      }),
    }),
    buildsGetRelays: build.query<Build[], ProjectIdParam & Pagination>({
      query: ({ project_id, offset, limit }) => ({
        url: `${project_id}/relays?offset=${offset}&limit=${limit}`,
      }),
    }),
  }),
})

export const { useBuildsGetDnsQuery, useBuildsGetRelaysQuery } = buildsApi
